import { render, staticRenderFns } from "./ElemTextarea.vue?vue&type=template&id=3fff151c&"
import script from "./ElemTextarea.vue?vue&type=script&lang=js&"
export * from "./ElemTextarea.vue?vue&type=script&lang=js&"
import style0 from "./ElemTextarea.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports